import type { ColumnDef } from '@tanstack/react-table';

/**
 * Raw column defs are often missing `id`; use accessor key fallback when present.
 * See https://tanstack.com/table/latest/docs/guide/column-defs#unique-column-ids
 */
export const getColumnDefId = <TData, TValue>(column: ColumnDef<TData, TValue>) => {
  if (typeof column.id === 'string') {
    return column.id;
  }
  if ('accessorKey' in column && typeof column.accessorKey === 'string') {
    return column.accessorKey;
  }
  return undefined;
};
